module.exports = __webpack_public_path__ + "static/img/qualifications_row_18.cf80d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_18.png
// module id = GszC
// module chunks = 1